// extracted by mini-css-extract-plugin
module.exports = {"one":"Ellipsis_one__zElG3","ellipsis":"Ellipsis_ellipsis__3jNN6","two":"Ellipsis_two__2xLtj","three":"Ellipsis_three__3hdzz"};